import { render, staticRenderFns } from "./binary.vue?vue&type=template&id=f4650e88"
import script from "./binary.vue?vue&type=script&lang=js"
export * from "./binary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports